import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AgendaMedicaFiltroDTO } from '../../dtos/agenda-medica-filtro-dto';
import { Filial } from '../../filial/filial';
import { FilialService } from '../../filial/filial.service';
import { Medico } from '../../medico/medico';
import { PlanoSaude } from '../../plano-saude/plano-saude';
import { PlanoSaudeService } from '../../plano-saude/plano-saude.service';
import { Procedimento } from '../../procedimento/procedimento';
import { ProcedimentoConsulta } from '../../procedimento/procedimento-consulta/procedimento-consulta';
import { ProcedimentoConsultaService } from '../../procedimento/procedimento-consulta/procedimento-consulta.service';
import { ChaveValorNumberInterface } from '../../util/chave-valor-number-interface';
import { Horario } from '../../util/hora-atendimeno';
import { Util } from '../../util/util';
import { AgendaMedica } from '../agenda-medica';
import { AgendaMedicaService } from '../agenda-medica.service';
import { AgendaMedicaPk } from '../pks/agenda-medica-pk';

@Component({
  selector: 'app-agenda-medica-horario-individual-maintenance',
  templateUrl: './agenda-medica-horario-individual-maintenance.component.html',
  styleUrls: ['./agenda-medica-horario-individual-maintenance.component.css']
})
export class AgendaMedicaHorarioIndividualMaintenanceComponent implements OnInit {

  id: AgendaMedicaPk;

  isUpdate: string;

  isInfo: boolean = false;

  agendaMedica: AgendaMedica;

  formularioAgendaMedicaHorarioIndividual: FormGroup;

  tituloCrud: string = '';

  listaDiasDaSemana: ChaveValorNumberInterface[] = Util.listaDiasDaSemana;

  listaHorarios: Horario[] = Util.listaHorasAtendimentos;

  listaFiliais: Filial[] = [];

  filtroAgendaMedica: AgendaMedicaFiltroDTO;

  medicoSelecionado: Medico | null;

  listaDeProcedimentoConsulta: ProcedimentoConsulta[] = [];

  procedimentosSelecionados: ProcedimentoConsulta[] = [];

  listaDePlanosDeSaude: PlanoSaude[] = [];

  planosSelecionados: PlanoSaude[] = [];

  totosOsPlanosSelecionados = false;

  totosOsProcedimentosSelecionados = false;

  planoSaudeSelecionarTodos: PlanoSaude = new PlanoSaude();

  procedimentoSelecionarTodos: Procedimento = new Procedimento();

  constructor(private agendaMedicaService: AgendaMedicaService,
    private filialService: FilialService,
    private procedimentoConsultaService: ProcedimentoConsultaService,
    private planoSaudeService: PlanoSaudeService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;

    this.isUpdate = history.state.isUpdate;

    this.agendaMedica = new AgendaMedica();

    this.filtroAgendaMedica = history.state.filtroAgendaMedica;

    if (this.filtroAgendaMedica && this.filtroAgendaMedica.medico) {
      this.medicoSelecionado = this.filtroAgendaMedica.medico;
    } else {
      this.medicoSelecionado = null;
    }

    this.configurarOpcaoDeSelecionarTodos();

    this.formularioAgendaMedicaHorarioIndividual = this.formBuilder.group({
      quantidadeAtd: [null, [Validators.required]],
      atdIdadeMinima: [null],
      atdIdadeMaxima: [null],
      atdPortadorNecessidade: [null],
      procedimentos: [null, [Validators.required]],
      planosDeSaude: [null, [Validators.required]],
      dataInicioAgenda: ['', [Validators.required]],
      pk: this.formBuilder.group({
        idFilial: [null, [Validators.required]],
        idMedico: [{ value: null, disabled: true }, [Validators.required]],
        diaSemana: [null, [Validators.required]],
        horaAtendimento: [null, [Validators.required]],
      })
    });
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Agenda Médica';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Agenda Médica';
      }
    } else {
      this.tituloCrud = 'Criar Agenda Médica';
    }

    this.listarFiliais();

    this.listarProcedimentosConsulta();

  }

  save() {

    this.agendaMedica = Object.assign(new AgendaMedica(), this.formularioAgendaMedicaHorarioIndividual.value);

    this.tratarListas();

    if (this.isUpdate == 'S') {

      this.agendaMedica.pk = this.id;

    } else if (this.medicoSelecionado) {

      this.agendaMedica.pk.idMedico = this.medicoSelecionado.id;

    }

    if (this.isNew()) {
      this.agendaMedicaService
        .criar(this.agendaMedica).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.agendaMedicaService.atualizar(this.agendaMedica)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/agendaMedica'], {
      state: {
        filtroAgendaMedica: history.state.filtroAgendaMedica,
      }
    });
  }

  isNew(): boolean {
    return this.id == null || this.id.idFilial == 0;
  }

  get formControl() {
    return this.formularioAgendaMedicaHorarioIndividual.controls;
  }

  listarFiliais() {

    if (this.medicoSelecionado) {

      this.filialService.listarFilialPorMedicoEEspecialidade(this.medicoSelecionado.id, this.medicoSelecionado.idEspecialidade)
        .subscribe(data => {

          // console.log(data)
          this.listaFiliais = data;

        }, error => {
          console.log(error);
        });
    }
  }

  listarProcedimentosConsulta() {

    if (this.medicoSelecionado) {
      this.procedimentoConsultaService
        .listarConsultasPorEspecialidadeComProjecao(this.medicoSelecionado.idEspecialidade)
        .subscribe(data => {

          this.listaDeProcedimentoConsulta = data;

          this.listarPlanosDeSaude();

        });
    }
  }

  listarPlanosDeSaude() {

    if (this.medicoSelecionado) {
      this.planoSaudeService
        .listarPlanoSaudePorMedicoComProjecao(this.medicoSelecionado.id)
        .subscribe(data => {

          this.listaDePlanosDeSaude = data;

          this.configurarForm();

        });
    }
  }

  configurarForm(): void {

    if (!this.isNew()) {

      this.agendaMedicaService.procurarAgendaMedicaPorPk(this.id)
        .subscribe(data => {
          // console.log(data)

          this.agendaMedica = Object.assign(new AgendaMedica(), data);

          this.formularioAgendaMedicaHorarioIndividual.patchValue(this.agendaMedica);

          // Configurar Campo Medico
          if (this.medicoSelecionado && this.formularioAgendaMedicaHorarioIndividual) {
            this.formularioAgendaMedicaHorarioIndividual.controls.pk.get('idMedico')?.patchValue(this.medicoSelecionado.nome);
          }

          // Configurar horario selecionado
          let currentHorario = this.listaHorarios.filter(hor => hor.descricao == Util.getHoraFormatada(this.agendaMedica.pk.horaAtendimento))[0];
          this.formControl.pk.get('horaAtendimento')?.patchValue(currentHorario.codigo);

          // Configurar lista de Prcedimentos Consultas selecionada
          //var listaDeProcedimentoConsultaPreSelecionada = null;
          if (this.agendaMedica.listaAgendaMedicaProcedimentoConsulta && this.agendaMedica.listaAgendaMedicaProcedimentoConsulta.length > 0) {

            const listaProcedimentosFromAgenda =
              this.agendaMedica.listaAgendaMedicaProcedimentoConsulta.map(agendaProcConsulta =>
                agendaProcConsulta.procedimentoConsulta);

            this.procedimentosSelecionados = this.listaDeProcedimentoConsulta.filter(function (listaFull) {
              return listaProcedimentosFromAgenda.some(function (listaFiltrada) {
                return listaFiltrada.id === listaFull.id;
              });
            });

            this.formControl.procedimentos.patchValue(this.procedimentosSelecionados);
          }

          // Configurar opcao de selecionar todos os Procedimentos.
          if (this.procedimentosSelecionados) {
            this.totosOsProcedimentosSelecionados = this.listaDeProcedimentoConsulta.length === this.procedimentosSelecionados.length;
          } else {
            this.totosOsProcedimentosSelecionados = false;
          }

          // Configurar lista de Planos de Saude seleionado
          if (this.agendaMedica.listaAgendaMedicaPlanoSaude && this.agendaMedica.listaAgendaMedicaPlanoSaude.length > 0) {

            const listaPlanosFromAgenda =
              this.agendaMedica.listaAgendaMedicaPlanoSaude.map(agendaPlanoSaude =>
                agendaPlanoSaude.planoSaude);

            this.planosSelecionados = this.listaDePlanosDeSaude.filter(function (listaFull) {
              return listaPlanosFromAgenda.some(function (listaFiltrada) {
                return listaFiltrada.id === listaFull.id;
              });
            });

            this.formControl.planosDeSaude.patchValue(this.planosSelecionados);
          }

          // Configurar opcao de selecionar todos os Planos.
          if (this.planosSelecionados) {
            this.totosOsPlanosSelecionados = this.listaDePlanosDeSaude.length === this.planosSelecionados.length;
          } else {
            this.totosOsPlanosSelecionados = false;
          }

          this.cd.detectChanges();

          if (this.isUpdate == 'N') {
            this.formularioAgendaMedicaHorarioIndividual.disable();
          } else {
            this.formularioAgendaMedicaHorarioIndividual.controls.pk.get('idFilial')?.disable();
            this.formularioAgendaMedicaHorarioIndividual.controls.pk.get('diaSemana')?.disable();
            this.formularioAgendaMedicaHorarioIndividual.controls.pk.get('horaAtendimento')?.disable();
          }

        }, error => {
          console.log(error);
        });
    } else {
      // Configurar Campo Medico
      if (this.medicoSelecionado && this.formularioAgendaMedicaHorarioIndividual) {
        this.formularioAgendaMedicaHorarioIndividual.controls.pk.get('idMedico')?.patchValue(this.medicoSelecionado.nome);
      }

      // Configurar opcao de selecionar todos os procedimentods.
      this.totosOsProcedimentosSelecionados = false;

      // Configurar opcao de selecionar todos procedimentos.
      this.totosOsPlanosSelecionados = false;
    }
  }

  get controlProcedimentos() {

    return this.formularioAgendaMedicaHorarioIndividual.controls.procedimentos;

  }

  get controlPlanosDeSaude() {

    return this.formularioAgendaMedicaHorarioIndividual.controls.planosDeSaude;

  }

  selecionarTodosOsProcedimentos() {
    this.totosOsProcedimentosSelecionados = !this.totosOsProcedimentosSelecionados;
    this.procedimentosSelecionados = this.totosOsProcedimentosSelecionados ? this.listaDeProcedimentoConsulta : [];
  }

  selecionarTodosOsPlanos() {
    this.totosOsPlanosSelecionados = !this.totosOsPlanosSelecionados;
    this.planosSelecionados = this.totosOsPlanosSelecionados ? this.listaDePlanosDeSaude : [];
  }

  tratarListas() {

    if (this.agendaMedica) {

      if (this.planosSelecionados) {
        this.planosSelecionados = this.planosSelecionados.filter(item => item.id != -1);
        this.agendaMedica.planosDeSaude = this.planosSelecionados;
      }

      if (this.procedimentosSelecionados) {
        this.procedimentosSelecionados = this.procedimentosSelecionados.filter(item => item.id != -1);
        this.agendaMedica.procedimentos = this.procedimentosSelecionados;
      }
    }
  }

  configurarOpcaoDeSelecionarTodos(): void {

    this.procedimentoSelecionarTodos = new Procedimento();
    this.procedimentoSelecionarTodos.id = -1;
    this.procedimentoSelecionarTodos.nome = 'Selecionar Todos';

    this.planoSaudeSelecionarTodos = new PlanoSaude();
    this.planoSaudeSelecionarTodos.id = -1;
    this.planoSaudeSelecionarTodos.nome = 'Selecionar Todos';

  }
}
